import React from "react";
import useFareRulesStatusInfoController from "./FareRulesStatusInfo.controller.js";
import { Icon, Stack } from "@bookingcom/bui-react";
import { PlaneTicketReturnIcon } from "@bookingcom/bui-assets-react/streamline";
import { Trans } from "@bookingcom/lingojs-react";
import useProfiler from "../../../../../../../hooks/useProfiler.js";
import { track } from "@flights/et-universal";
const useFareRulesStatusInfo = (flight) => {
    const data = useFareRulesStatusInfoController(flight);
    const { header, fareRulesContent } = data;
    const { isMobile, isDesktop } = useProfiler();
    if (!fareRulesContent)
        return undefined;
    return {
        header,
        content: (isDesktop() && !!track("flights_funnel_new_fd_page_desktop")) ||
            (isMobile() && !!track("flights_funnel_new_fd_page_mobile")) ? (React.createElement(Trans, { tag: fareRulesContent.copyTag, components: [React.createElement("strong", { key: 0 })], variables: { airline: fareRulesContent.carrierName, start_bold: "<0>", end_bold: "</0>" } })) : (React.createElement(Stack, { direction: "row", gap: 4 },
            React.createElement("div", null,
                React.createElement(Icon, { svg: PlaneTicketReturnIcon, size: "larger" })),
            React.createElement(Stack.Item, { grow: true },
                React.createElement(Trans, { tag: fareRulesContent.copyTag, components: [React.createElement("strong", { key: 0 })], variables: { airline: fareRulesContent.carrierName, start_bold: "<0>", end_bold: "</0>" } }))))
    };
};
export default useFareRulesStatusInfo;
